import useController from "@hooks/useController";

export default function useConfigController(): Controllers.Config {
    const controller = useController("/api/config")

    const show = () => controller.get()

    return { show }
}